import { define } from 'wicked-elements'

define('[data-component="share-button"]', {
  init() {
    // Hide the button if Web Share API is not supported
    if (!('share' in navigator)) {
      this.element.style.display = 'none'
      return
    }
    this.shareData = {
      title: this.element.dataset.shareTitle || document.title,
      text: this.element.dataset.shareText || 'Check this out on GP.LA',
      url: this.element.dataset.shareUrl || window.location.href
    }
    this.element.addEventListener('click', () => this.share())
  },

  async share() {
    try {
      await navigator.share(this.shareData)
    } catch (error) {
      // User cancelled or error occurred; do nothing
    }
  }
}) 